import React from "react";
import SEO from "../commons/SEO";
import HeaderOne from "../commons/header/HeaderOne";
import ServiceOne from "../element/service/ServiceOne";

const HomeDefault = () => {
  return (
    <>
      <SEO title="Нүүр" />
      <main className="page-wrapper">
        <HeaderOne
          btnStyle="btn-small round btn-icon"
          HeaderSTyle="header-transparent"
        />

        {/* Start Slider Area  */}
        <div
          className="slider-area slider-style-1 variation-default height-850 bg_image"
          data-black-overlay="7"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/header.jpg)`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner text-center">
                  <span className="subtitle">Таны бэлгийн боловсрол</span>
                  <h1 className="title display-one">SEDU</h1>
                  <p className="description">
                    Sedu бол таны сексийн амьдрал, бэлгийн боловсролд дэмжлэг
                    үзүүлэх үнэнч туслах. Олон төрлийн нийтлэл, танин мэдэхүйн
                    мэдээлэл, багшийн хичээл гэх мэт үр өгөөжтэй контентуудаас
                    бүрдэнэ.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Slider Area  */}

        {/* Start Service Area  */}
        <div className="rn-service-area rn-section-gapBottom pt--100">
          <div className="container">
            <ServiceOne
              serviceStyle="service__style--1 icon-circle-style"
              textAlign="text-center"
            />
          </div>
        </div>
        {/* End Service Area  */}
      </main>
    </>
  );
};
export default HomeDefault;
